module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-join col-md-2 col-sm-2 col-xs-6"
  }, [_c('div', {
    staticClass: "board"
  }, [_c('div', {
    staticClass: "board-img"
  }, [(_vm.item.thumbnail !== undefined && _vm.item.thumbnail !== null && _vm.item.thumbnail.length > 0) ? _c('img', {
    attrs: {
      "src": _vm.item.thumbnail
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../assets/images/faces/ic_AvatarDefault@2x.png")
    }
  })]), _c('div', {
    staticClass: "board-info"
  }, [_c('div', {
    staticClass: "title-classes"
  }, [_c('span', [_vm._v(_vm._s(_vm.item.name))])]), (!_vm.$store.getters.isLoggedIn || (_vm.$store.getters.fullname !== undefined && _vm.$store.getters.fullname !== null && _vm.$store.getters.fullname.type_user !== 2)) ? _c('div', [(_vm.$store.getters !== null && _vm.$store.getters.isLoggedIn && _vm.status === 2) ? _c('button', {
    staticClass: "btn-join ticket",
    on: {
      "click": function($event) {
        return _vm.onClassOfUser(_vm.item)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/faces/ic_check@2x.png")
    }
  }), _c('span', [_vm._v(_vm._s(this.$t('landing.joined')))])]) : (_vm.$store.getters !== null && _vm.$store.getters.isLoggedIn && _vm.status === 1) ? _c('button', {
    staticClass: "btn-join"
  }, [_vm._v(_vm._s(this.$t('landing.send_requested')))]) : _c('button', {
    staticClass: "btn-join active",
    on: {
      "click": function($event) {
        return _vm.joinNow(_vm.item)
      }
    }
  }, [_vm._v(_vm._s(this.$t('landing.join_now')))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e3c6834","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Front/LandingPage/itemClasses.vue
// module id = 1539
// module chunks = 0